/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamAnalysisTaskItemAreaDataDtoCorrections } from './BeamAnalysisTaskItemAreaDataDtoCorrections';
import {
    BeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSON,
    BeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSONTyped,
    BeamAnalysisTaskItemAreaDataDtoCorrectionsToJSON,
} from './BeamAnalysisTaskItemAreaDataDtoCorrections';

/**
 * 
 * @export
 * @interface BeamAnalysisTaskItemAreaDataDto
 */
export interface BeamAnalysisTaskItemAreaDataDto {
    /**
     * 
     * @type {BeamAnalysisTaskItemAreaDataDtoCorrections}
     * @memberof BeamAnalysisTaskItemAreaDataDto
     */
    corrections?: BeamAnalysisTaskItemAreaDataDtoCorrections | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisTaskItemAreaDataDto
     */
    $type?: BeamAnalysisTaskItemAreaDataDtoTypeEnum;
}


/**
 * @export
 */
export const BeamAnalysisTaskItemAreaDataDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationTaskItemComponentDtoBeamAnalysisTaskItemAreaDataDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.TaskItemComponent.Dto.BeamAnalysisTaskItemAreaDataDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type BeamAnalysisTaskItemAreaDataDtoTypeEnum = typeof BeamAnalysisTaskItemAreaDataDtoTypeEnum[keyof typeof BeamAnalysisTaskItemAreaDataDtoTypeEnum];



/**
 * Check if a given object implements the BeamAnalysisTaskItemAreaDataDto interface.
 */
export function instanceOfBeamAnalysisTaskItemAreaDataDto(value?: unknown): value is BeamAnalysisTaskItemAreaDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamAnalysisTaskItemAreaDataDtoTypeEnum)[0];
}

export function BeamAnalysisTaskItemAreaDataDtoFromJSON(json: any): BeamAnalysisTaskItemAreaDataDto {
    return BeamAnalysisTaskItemAreaDataDtoFromJSONTyped(json, false);
}

export function BeamAnalysisTaskItemAreaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisTaskItemAreaDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'corrections': json['corrections'] == null ? undefined : BeamAnalysisTaskItemAreaDataDtoCorrectionsFromJSON(json['corrections']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamAnalysisTaskItemAreaDataDtoToJSON(value?: BeamAnalysisTaskItemAreaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'corrections': BeamAnalysisTaskItemAreaDataDtoCorrectionsToJSON(value['corrections']),
        '$type': value['$type'],
    });
}

